module.exports = __webpack_public_path__ + "static/media/attack.4bb3fcb3.png";